import { useStoreState } from '@/stores/store';
import { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import DefaultPreference from 'react-native-default-preference';

export const useLastEmail = () => {
  const [lastEmail, setLastEmail] = useState('');
  const lastEmailLogin = useStoreState((state) => state.lastLoginEmail);

  const migrateEmailFromIonic = async () => {
    // migrate email address on iOS or Android from DefaultPreferences
    if (Platform.OS === 'ios' || Platform.OS === 'android') {
      try {
        if (Platform.OS === 'android') {
          await DefaultPreference.setName('NativeStorage');
        }
        // await DefaultPreference.set('usermail', 'brudi@neolexon.de');
        let ionicEmail = await DefaultPreference.get('usermail');
        if (ionicEmail) {
          try {
            return JSON.parse(ionicEmail);
          } catch {
            return ionicEmail;
          } finally {
            await DefaultPreference.clear('usermail');
          }
        }
      } catch {}
    } else if (Platform.OS === 'web') {
      const item = window.localStorage.getItem('ngStorage-saveUsername');
      if (!item) {
        return '';
      }
      try {
        return JSON.parse(item);
      } catch {
        return item;
      }
    }
  };

  useEffect(() => {
    const getLastEmail = async () => {
      const migratedEmail = await migrateEmailFromIonic();
      setLastEmail(migratedEmail ?? '');
    };
    getLastEmail();
  }, []);

  return lastEmail || lastEmailLogin;
};
